const indicadoresVivosModulo = {
    agGrid: {
        paginacion: 15,
        id: 'myGrid',
        class: 'ag-theme-alpine',
        style: {
            width: '100%',
            height: '700px'
        }
    },
    titulos: {
        consultaDeProcesos: {
            titulo: 'Consulta de Procesos',
            modulo: 'RPlus',
            tituloCardListar: 'Listar Consultas de Procesos',
        },
        ejecucionDeProcesos: {
            titulo: 'Ejecución de Procesos',
            modulo: 'RPlus',
            tituloCardListar: 'Listar Ejecución de Procesos',
        },
        parametrizarValorFlete: {
            titulo: 'Valor de Flete',
            modulo: 'Balanza',
            tituloCardListar: 'Listar Valor de Flete',
            tituloAgregar: 'Agregar Valor de Flete',
            tituloActualizar: 'Actualizar Valor de Flete'
        },

    },
    agGridModal: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-material mt-3',
        style: {
            width: '100%',
            height: '450px'
        }
    },
    url: {
        indicadores: {
            recepcionCsv: 'indicadores-vivos/recepcion/csv',//subir csv
            recepcionCsvSave: 'indicadores-vivos/recepcion/csv/save/',//guardar datos del csv
            presupuestoVentas: 'indicadores-vivos/presupuestoVenta',//get crear y actualizar
            presupuestoVentasDelete: 'indicadores-vivos/presupuestoVenta/delete',//eliminar
            
            recepcionCsvMarcasfacturas: 'presupuesto-factura/upload/csv/save',//subir csv
            recepcionCsvSaveMarcasFacturas: 'presupuesto-factura/recepcion/csv/save/',//guardar datos del csv
            presupuestoVentasMarcasFacturas: 'presupuesto-factura/',//get crear y actualizar
            presupuestoVentasMarcasFacturasFiltrar: 'presupuesto-factura/filtrar',//filtrar
            presupuestoVentasDeleteMarcasFacturas: 'presupuesto-factura/delete',//eliminar
            
            recepcionCsvSellOut: 'presupuesto-sellout/upload/csv/save',//subir csv
            recepcionCsvSaveSellOut: 'presupuesto-sellout/recepcion/csv/save',//guardar datos del csv
            recepcionCsvSellOutTodos: 'presupuesto-sellout/obtener',//obtener todos
            presupuestoSellOut: 'presupuesto-sellout',//get crear y actualizar
            presupuestoSellOutDelete: 'presupuesto-sellout/delete',//eliminar

            getClienteInBann: '/vendedor/id/',
            changePresupuestoVenta: 'indicadores-vivos/changePresupuestoVenta',
            getChangePresupuestoVenta: 'indicadores-vivos/getChangePresupuestoVenta',
            getVersionPresupuesto: 'indicadores-vivos/getVersionPresupuesto',
            usuarioDirecciones: 'indicadores-vivos/usuario-direcciones',
            direcciones: 'indicadores-vivos/direcciones',
            reporte: 'indicadores-vivos/presupuesto/filtrar',
            presupuestoVenta    : 'indicadores-vivos/presupuestoVenta/filtrar',

            propiedadesUpload   : 'presupuesto-propiedades/csv/upload',
            propiedadesSave     : 'presupuesto-propiedades/csv/save',
            propiedadesCrud     : 'presupuesto-propiedades',

            //T25111 add presupuesto promocional
            promocionUpload     : 'presupuesto-promocion/csv/upload',
            promocionSave       : 'presupuesto-promocion/csv/save',
            promocionCrud       : 'presupuesto-promocion',
            promocionReport     : 'presupuesto-promocion/all/transversal',
        },

        versiones: {
            obtenerTodo: 'versiones/all',
            obtenerPorId: 'versiones/',
            obtenerVersionActiva: 'versiones/activo',
            crear: 'versiones/save',
            actualizar: 'versiones/actualizar',
            eliminar: 'versiones/'
        },
        maestros: {
            getAgencias: 'oficina-venta',
            getVendedor: '/vendedor/id/',
        },
    },
    button: {
        buttonsCss: {
            primary: 'btn btn-primary btn-block',
            secondary: 'btn btn-secondary btn-block',
            success: 'btn btn-success btn-block',
            danger: 'btn btn-danger btn-block',
            warning: 'btn btn-warning btn-block',
            info: 'btn btn-info btn-block',
            light: 'btn btn-light btn-block',
            dark: 'btn btn-dark btn-block',
            primaryOutline: 'btn btn-outline-primary',
            secondaryOutline: 'btn btn-outline-secondary',
            successOutline: 'btn btn-outline-success',
            dangerOutline: 'btn btn-outline-danger',
            warningOutline: 'btn btn-outline-warning',
            infoOutline: 'btn btn-outline-info',
            lightOutline: 'btn btn-outline-light',
            darkOutline: 'btn btn-outline-dark',
            primarylg: 'btn btn-primary btn-lg btn-block',
            successLg: 'btn btn-success btn-lg btn-block',
            dangerLg: 'btn btn-danger btn-lg btn-block',
            warningLg: 'btn btn-warning btn-lg btn-block',
            warningLgFile: 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar: 'Editar',
            ver: 'Ver',
            eliminar: 'Eliminar',
            agregar: 'Agregar ',
            guardar: 'Guardar',
            actualizar: 'Actualizar',
            mostrar: 'Mostrar seleccion',
            regresar: 'Regresar',
            continuar: 'Continuar',
            seleccionar: 'Seleccionar',
            procesar: 'Procesar',
            buscar: 'Buscar',
            sustento: 'Sustento',
            validar: 'Validar',
            descargar: 'Descargar',
            descargarRecibo: 'Descargar Recibo Cobros',
            descargarEstado: 'Descargar Estados Docs',
            detalle: 'Ver Ordenes',
            agregarProducto: 'Añadir Productos',
            anadirProducto: 'Añadir',
            limpiar: 'Eliminar todos los productos',
            anular: 'Anular',
            aprobar: 'Aprobar',
            cambiarPresupuesto: 'Cambiar Vendedor Presupuesto',
        }
    },
    mensajes: {
        errorServicio: 'error..!!',
        desabilitada: 'Opción desabilitada',
        eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
        guardar: '¿Esta seguro que desea guardar el siguiente elemento?',
        actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
        datoGuardado: 'Se guardo corectamente..!!',
        guardarParada: 'Esta seguro que desea registrar este evento..??',
        procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
        validar: '¿Esta seguro que desea validar el siguiente elemento?',
        anticipo: 'Se tomara este valor como anticipo.',
        camposObligatorio: 'Los campos tipo transaccion y número documento deben estar llenos caso contrario se tomara como anticipo.',
        anular: 'Confirma que desea eliminar el registro seleccionado.',
        cambiarPresupuesto: '¿Está seguro que desea cambiar el código vendedor de los siguientes registros?'
    },
    colors: {
        verde: 'green',
        azul: 'blue',
        rojo: 'red'
    },
    imagenes: {
        regalo: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>',
        item: '<span><img src="../../../assets/image/regalo.png" height="30" width="30"></i></span>'
    },
    div: {
        resposiveFull: 'col-12 col-sm-6 col-md-6 col-lg-4 ',//verificar el tipo de pantalla
    }
}


export { indicadoresVivosModulo }